module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f428.6ea80059.svg";